import React, { useState } from "react";
import PageHero from "@/components/shared/PageHero";
import { FormShell, SuccessPopup } from "@/components/shared/FormShell";
import { DISTRICTS } from "@/data/mock";
import { HeartHandshake } from "lucide-react";

export default function Volunteer() {
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ name: "", district: "", profession: "", skills: "", availability: "" });
    return (
        <>
            <PageHero
                testId="volunteer-page"
                eyebrow="Volunteer"
                chapter="Service · 05"
                title="Join the field."
                subtitle="Volunteers are the connective tissue of every meaningful initiative. Tell us where you are, and what you're good at."
            />
            <FormShell
                aside={
                    <div>
                        <div className="eyebrow mb-4">Where you&apos;ll fit</div>
                        <p className="text-[14px] leading-relaxed text-slate-600">
                            We match volunteers with active district initiatives — from skilling drives to
                            neighbourhood safety, digital hubs and cultural programmes.
                        </p>
                        <div className="mt-6 flex items-center gap-3 rounded-2xl border border-ink/10 bg-white p-4 text-[13px] text-slate-500">
                            <HeartHandshake className="h-5 w-5 text-pink" />
                            1,560 volunteers active across 33 districts.
                        </div>
                    </div>
                }
            >
                <form className="space-y-8" onSubmit={(e) => { e.preventDefault(); setOpen(true); }} data-testid="volunteer-form">
                    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                        <div className="field">
                            <label>Name</label>
                            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" data-testid="vol-name" />
                        </div>
                        <div className="field">
                            <label>District</label>
                            <select required value={form.district} onChange={(e) => setForm({ ...form, district: e.target.value })} data-testid="vol-district">
                                <option value="">Select district</option>
                                {DISTRICTS.map((d) => <option key={d} value={d}>{d}</option>)}
                            </select>
                        </div>
                        <div className="field">
                            <label>Profession</label>
                            <input required value={form.profession} onChange={(e) => setForm({ ...form, profession: e.target.value })} placeholder="e.g., Educator, Designer" data-testid="vol-profession" />
                        </div>
                        <div className="field">
                            <label>Availability</label>
                            <select required value={form.availability} onChange={(e) => setForm({ ...form, availability: e.target.value })} data-testid="vol-availability">
                                <option value="">Select availability</option>
                                <option>Weekends</option>
                                <option>Weeknights</option>
                                <option>Full-time</option>
                                <option>Ad-hoc</option>
                            </select>
                        </div>
                    </div>
                    <div className="field">
                        <label>Skills</label>
                        <textarea rows={4} required value={form.skills} onChange={(e) => setForm({ ...form, skills: e.target.value })} placeholder="What you can bring — languages, tools, life experience." data-testid="vol-skills" />
                    </div>
                    <div className="flex items-center gap-4 pt-4">
                        <button type="submit" className="btn-primary" data-testid="vol-submit">Join community</button>
                    </div>
                </form>
            </FormShell>
            <SuccessPopup open={open} onClose={() => setOpen(false)} title="Welcome to the community" body="We'll pair you with an initiative in your district. Watch for the welcome kit on your email." />
        </>
    );
}
